module.exports = __webpack_public_path__ + "media/images/flags/64/Bermuda-2635dcd7d1b9ce0316b4a6ab0aae153e.png";